import { AutoMap } from "@automapper/classes"

export class MesureGenericDTO {
    @AutoMap()
    code: string = ''
    @AutoMap()
    name: string = ''
    @AutoMap()
    groupName: string = ''
    @AutoMap()
    testCode: string = ''
    @AutoMap()
    reference: string = ''
    @AutoMap()
    isCancelled: boolean = false
    @AutoMap()
    samplingId?: number
    @AutoMap()
    interventionId?: number
}